import styled from "@emotion/styled";
import { Body2 } from "@material/react-typography";
import { Dialog } from "~/components/dialog";

/**
 * The MDC dialog surface has no horizontal padding of its own, so form fields
 * (which carry `margin: 16px`) sit tight against the edge and `FormBottomRow`
 * -- which brings no spacing -- lands flush in the corner. Pad the surface so
 * the fields, guidance text and buttons share one gutter.
 */
export const ProductDialog = styled(Dialog)`
  .mdc-dialog__surface {
    min-width: 480px;
    padding: 0 8px 12px;
  }
`;

/**
 * Guidance text beneath a form field. Matches the 16px side margin
 * `section.form-field` carries so the two line up.
 */
export const FieldNote = styled(Body2)`
  margin: 0 16px 12px;
`;
